// ─── Design System ────────────────────────────────────────────────────────────
export const DS = {
  cream:    '#FAF8F5',
  white:    '#FFFFFF',
  sand:     '#EDE9E1',
  stone:    '#C4BAA8',
  ink:      '#1A1714',
  ink2:     '#2E2820',
  gold:     '#9C7B4E',
  goldLight:'#D4B896',
  muted:    '#7A736B',
  border:   '#E8E2D9',
  borderLight: '#F0EDE8',
};

export const FONTS_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400;1,600&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap');
  .vr { font-family:'DM Sans',sans-serif; background:${DS.cream}; color:${DS.ink}; min-height:100vh; }
  .vr-serif { font-family:'Cormorant Garamond',serif; }
  .chip-scroll::-webkit-scrollbar { display:none; }
  .chip-scroll { scrollbar-width:none; -ms-overflow-style:none; }
  @keyframes vFadeUp { from{opacity:0;transform:translateY(18px)} to{opacity:1;transform:translateY(0)} }
  @keyframes vShimmer { 0%{background-position:-200% 0} 100%{background-position:200% 0} }
  .card-img img { transition: transform 0.5s ease; }
  .card-img:hover img { transform: scale(1.06); }
  .vr-card:hover { transform:translateY(-3px); box-shadow:0 12px 32px rgba(26,23,20,0.12) !important; }
  @media(max-width:767px) {
    .vr-grid { grid-template-columns: repeat(2,1fr) !important; gap:10px !important; }
    .vr-hero { flex-direction:column !important; padding:2rem 1.25rem !important; }
    .vr-hero-badge { width:64px !important; height:64px !important; }
    .vr-hero-badge .vr-badge-num { font-size:28px !important; }
    .vr-hero-h1 { font-size:36px !important; }
    .vr-nav-inner { padding:0.75rem 1.25rem !important; }
    .vr-filter-inner { padding:0.75rem 1.25rem !important; flex-direction:column !important; gap:0 !important; align-items:stretch !important; }
    .vr-filter-search { width:100% !important; max-width:100% !important; margin-bottom:12px !important; }
    .vr-filter-top-row { display:flex !important; justify-content:space-between !important; align-items:center !important; margin-bottom:10px !important; }
    .vr-filter-chips { width:100% !important; display:flex !important; flex-wrap:nowrap !important; overflow-x:auto !important; gap:8px !important; padding-bottom:4px !important; scrollbar-width:none !important; -ms-overflow-style:none !important; }
    .vr-filter-chips::-webkit-scrollbar { display:none !important; }
    .vr-filter-sort { order:unset !important; margin-left:0 !important; }
    .vr-main { padding:0 1.25rem !important; }
    .vr-section-hdr { padding:0 1.25rem !important; }
    .vr-footer-inner { padding:1.25rem 1.25rem !important; flex-direction:column !important; text-align:center !important; gap:0.75rem !important; }
    .vr-nav-btns span { display:none; }
    .vr-detail-modal { grid-template-columns:1fr !important; max-height:92vh !important; }
    .vr-detail-img { height:240px !important; min-height:240px !important; border-radius:16px 16px 0 0 !important; }
    .vr-detail-info { padding:20px 16px !important; }
  }
`;

// ─── Utilities ────────────────────────────────────────────────────────────────
export const getImageSrc = (product) => {
  const image = product?.image || product?.photo;
  if (!image) return null;
  if (image.startsWith('data:')) return image;
  if (image.startsWith('http')) return image;
  return `data:image/jpeg;base64,${image}`;
};
